import PreferenceSelectorNoInfo, {
  PreferenceSelectorNoInfoProps,
} from './PreferenceSelectorNoInfo';

export type {PreferenceSelectorNoInfoProps};
export default PreferenceSelectorNoInfo;
